import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  SearchBar,
  Pagination,
  TableItemsTextLiterature,
} from "../../components";
import { closeModal } from "../../store/slices/deleteModalSlice";
import {
  fetchDataTextLiterature,
  setPage,
} from "../../store/slices/apiLiteratureSlice";
import AddModalTextLiterature from "../Modals/AddModalTextLiterature";
import TableItemsTextLiteratureResponsive from "../TableItemsTextLiterature/TableItemsTextLiteratureResponsive";

const TableTextLiterature = () => {
  const dispatch = useDispatch();

  const backendBaseUrl = "https://back2.autoshkollaime.com";
  const dataText = useSelector((state) => state.apiLiterature.dataTextLirature);
  const currentPage = useSelector((state) => state.apiLiterature.currentPage);
  const totalCount = useSelector((state) => state.apiLiterature.totalCount);

  const [searchInput, setSearchInput] = useState("");
  const prevSearchRef = useRef ("");

  useEffect(() => {
    const pageToUse =
      prevSearchRef.current !== searchInput ? 1 : currentPage;
  
    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1));
      prevSearchRef.current = searchInput;
    }
  
    dispatch(fetchDataTextLiterature({ page: pageToUse, searchQuery: searchInput }));
  }, [dispatch, currentPage, searchInput]);
  

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      fetchDataTextLiterature({ page: currentPage, searchQuery: searchInput })
    );
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <div className="p-3">
      <div className="flex flex-col sm:flex-row items-center justify-between pb-4 bg-white dark:bg-gray-900 space-y-4 sm:space-y-0">
        <div className="w-full sm:w-auto flex-grow">
          <SearchBar
            searchInput={searchInput}
            handleSearchInputChange={handleSearchInputChange}
            handleSearchSubmit={handleSearchSubmit}
          />
        </div>
        <div className="w-full sm:w-auto flex justify-center sm:justify-end">
          <button className="text-blue-500 mx-2" alt="you can edit here">
            <AddModalTextLiterature
              title="Shto një tekst"
              submitButtonText="Shto tekstin"
              onCancel={handleCloseModal}
              inputLabel1="Emri i testit"
              inputLabel2="Zgjedh Subliteraturen"
            />
          </button>
        </div>
      </div>

      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <div className="hidden sm:block">
          <table className="min-w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  Emri i Tekstit
                </th>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  Teksti
                </th>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  Emri I Literatures
                </th>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  Emri i Kategoris
                </th>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  Foto
                </th>
                <th scope="col" className="px-4 py-3 whitespace-nowrap">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <TableItemsTextLiterature
                dataTextLiterature={dataText}
                baseUrl={backendBaseUrl}
              />
            </tbody>
          </table>
        </div>
        <div className="block sm:hidden space-y-4">
          <TableItemsTextLiteratureResponsive
            dataTextLiterature={dataText}
            baseUrl={backendBaseUrl}
          />
        </div>
      </div>

      <Pagination
        currentPage={currentPage}
        totalCount={totalCount}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default TableTextLiterature;
